import"../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{illustration as l}from"../../illustration-registry.js";const o=l("mortgage",t`
        <svg width="168" height="168" viewBox="0 0 168 168" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_3736_599)">
            <g style="mix-blend-mode:multiply">
            <path d="M49.9477 26.88C68.7543 45.6865 99.2458 45.6865 118.052 26.88L141.12 49.9476C109.573 81.4941 58.4265 81.494 26.88 49.9476L49.9477 26.88Z" fill="#8EDB7A"/>
            </g>
            <g style="mix-blend-mode:multiply">
            <path d="M141.12 118.052C122.313 99.2458 122.313 68.7544 141.12 49.9479L118.052 26.8802C86.5058 58.4267 86.5058 109.574 118.052 141.12L141.12 118.052Z" fill="#17A9DC"/>
            </g>
            <g style="mix-blend-mode:multiply">
            <path d="M26.8801 49.9478C45.6867 68.7543 45.6867 99.2457 26.8801 118.052L49.9478 141.12C81.4943 109.573 81.4943 58.4265 49.9478 26.8801L26.8801 49.9478Z" fill="#FABA00"/>
            </g>
            </g>
            <defs>
            <clipPath id="clip0_3736_599">
            <rect width="116" height="116" fill="white" transform="translate(26 26)"/>
            </clipPath>
            </defs>
        </svg>
    `);export{o as Mortgage};
